import { FocusTarget } from "./focusTarget";
import { useLayoutEffect } from "react";
import { createDisposables } from "./useDisposables";
import { useChainedEventCallback } from "./useChainedEventCallback";
import { useEventCallback } from "./useEventCallback";

function useAbstractAutoFocus({
  delay,
  isDisabled,
  onFocus
}) {
  useLayoutEffect(() => {
    const disposables = createDisposables();

    if (!isDisabled) {
      if (delay) {
        disposables.setTimeout(() => {
          onFocus();
        }, delay);
      } else {
        disposables.nextFrame(() => {
          onFocus();
        });
      }
    }

    return () => {
      disposables.dispose();
    };
  }, [isDisabled, delay, onFocus]);
}

export function useAutoFocus(targetRef, {
  delay,
  isDisabled,
  onFocus
} = {}) {
  useAbstractAutoFocus({
    delay,
    isDisabled,
    onFocus: useChainedEventCallback(onFocus, () => {
      var _targetRef$current, _targetRef$current2;

      if (!((_targetRef$current = targetRef.current) !== null && _targetRef$current !== void 0 && _targetRef$current.hasAttribute("disabled")) && !((_targetRef$current2 = targetRef.current) !== null && _targetRef$current2 !== void 0 && _targetRef$current2.contains(document.activeElement))) {
        var _targetRef$current3;

        (_targetRef$current3 = targetRef.current) === null || _targetRef$current3 === void 0 ? void 0 : _targetRef$current3.focus();
      }
    })
  });
}
export function useAutoFocusChild(focusManager, {
  target = FocusTarget.first,
  isDisabled,
  delay,
  canFocus,
  onFocus,
  onNotFound
} = {}) {
  useAbstractAutoFocus({
    delay,
    isDisabled: isDisabled,
    onFocus: useEventCallback(() => {
      // Do not autofocus another child if there is already one focused.
      if (!focusManager.isInScope(document.activeElement)) {
        focusManager.focusTarget(target, {
          canFocus,
          onFocus,
          onNotFound
        });
      }
    })
  });
}